export const paginateModalSlider = (arr: any, limit: number) => {
	return arr.reduce((acc: any, val: number, i: number) => {
		let idx = Math.floor(i / limit);
		let page = acc[idx] || (acc[idx] = []);
		page.push(val);
		return acc;
	}, []);
};